import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import {
    Button,
    Form,
    Input,
    Radio,
    Select,
    DatePicker,
    Upload,
    Space,
    message,
    InputNumber,
} from 'antd';
import axios from 'axios';
import { baseUrl } from '../../config/apiConfig';
import tokenStore from '../../stores/TokenStore';
import categories from "../../data/categories.json";
import mcc from "../../data/mcc.json"



const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList;
};

const NewMerchantPage = () => {
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const handleSubmit = async (values) => {
        const formattedData = {
            email: values.email,
            phone: values.contactMobileNumber,
            name: values.name,
            companyRegistrationName: values.companyName,
            abbreviatedCompanyName: values.abbreviatedCompanyName,
            registrationArea: values.operatingCountryOrRegion,
            merchantType: values.merchantType,
            businessCategory: values.businessCategory,
            mccCode: values.mccCode,
            certificateNumber: values.registrationCertificateNumber,
            expirationCertificate: values.expirationDateOfRegistrationCertificate,
            certificateImg: '', // 文件上传返回的图片 URL
            serviceRate: values.serviceRate / 100,
            settlementCycle: values.settlementCycle,
            website: values.website,
            appDownloadLink: values.appDownloadLink,
            officialAccount: values.officialAccount,
            miniProgram: values.miniProgram,
            storeAddress: values.storeAddress,
            storePhotos: '', // 文件上传后获得的链接集合
            directorName: values.directorName,
            directorIdNumber: values.directorIdNumber,
            settlementBankNo: values.settlementBankNo,
            businessType: values.businessType,
        };

        try {
            const response = await axios.post(baseUrl + '/merchant/create_merchant', formattedData, {
                headers: { token: tokenStore.token },
            });
            if (response.data.code === 200) {
                messageApi.success('Merchant created successfully!');
                form.resetFields();
            } else {
                messageApi.error(response.data.msg || 'Submission failed!');
            }
        } catch (error) {
            messageApi.error('An error occurred while submitting the form.');
        }
    };

    return (
        <>
            {contextHolder}
            <Form
                form={form}
                name="new-merchant"
                labelCol={{ flex: '280px' }}
                labelAlign="left"
                labelWrap
                wrapperCol={{ flex: 1 }}
                onFinish={handleSubmit}
                style={{ maxWidth: 600 }}
            >
                <Form.Item label="Company Registration Name" name="companyName" rules={[{ required: true, message: 'Please input company name!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Abbreviated Company Name" name="abbreviatedCompanyName" rules={[{ required: true, message: 'Please input abbreviated company name!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Operating Country or Region" name="operatingCountryOrRegion" rules={[{ required: true, message: 'Please select operating country or region!' }]}>
                    <Select>
                        <Select.Option value="124">Canada</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item label="Merchant Type" name="merchantType" rules={[{ required: true, message: 'Please select merchant type!' }]}>
                    <Radio.Group >
                        <Radio value="ENTERPRISE">Enterprise</Radio>
                        <Radio value="INDIVIDUAL" disabled>Individual</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item
                    label="Business Category"
                    name="businessCategory"
                    rules={[{ required: true, message: 'Please select business category!' }]}
                >
                    <Select
                        showSearch
                        options={categories.map((item) => ({
                            value: item.code,
                            label: item.code + " | " + item.description,
                        }))}
                        style={{ width: "100%" }}
                        placeholder="Select a category"
                        filterOption={(input, option) =>
                            option?.label.toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Form.Item>

                <Form.Item label="MCC Code" name="mccCode" rules={[{ required: true, message: 'Please select MCC code!' }]}>
                    <Select
                        showSearch
                        options={mcc.map((item) => ({
                            value: item.mcc,
                            label: item.mcc + " | " + item.merchant_category + " | " + item.description,
                        }))}
                        style={{ width: "100%" }}
                        placeholder="Select a MCC"
                        filterOption={(input, option) =>
                            option?.label.toLowerCase().includes(input.toLowerCase())
                        }
                    />
                </Form.Item>
                <Form.Item label="Registration Certificate Number" name="registrationCertificateNumber" rules={[{ required: true, message: 'Please input registration certificate number!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Expiration Date of Registration Certificate"
                    name="expirationDateOfRegistrationCertificate"
                    rules={[{ required: true, message: 'Please select expiration date!' }]}
                >
                    <DatePicker />
                </Form.Item>



                <Form.Item label="Business Type" name="businessType" rules={[{ required: true, message: 'Please select business type!' }]}>
                    <Radio.Group >
                        <Radio value="ONLINE">Online</Radio>
                        <Radio value="OFFLINE">Offline</Radio>
                        <Radio value="BOTH">Both</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item
                    label="Website"
                    name="website"
                    dependencies={['businessType']}
                    rules={[
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                const businessType = getFieldValue('businessType');
                                if ((businessType === 'ONLINE' || businessType === 'BOTH') && !value) {
                                    return Promise.reject(new Error('Please input website!'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="App Download Link" name="appDownloadLink">
                    <Input />
                </Form.Item>
                <Form.Item label="Official Account" name="officialAccount">
                    <Input />
                </Form.Item>
                <Form.Item label="Mini Program" name="miniProgram">
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Store Address"
                    name="storeAddress"
                    dependencies={['businessType']}
                    rules={[
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                const businessType = getFieldValue('businessType');
                                if ((businessType === 'OFFLINE' || businessType === 'BOTH') && !value) {
                                    return Promise.reject(new Error('Please input store address!'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Store Photos" name="storePhotos" valuePropName="fileList" getValueFromEvent={normFile}>
                    <Upload action="/upload.do" listType="picture-card">
                        <div>
                            <PlusOutlined />
                            <div>Upload</div>
                        </div>
                    </Upload>
                </Form.Item>
                <Form.Item label="Director Name" name="directorName" rules={[{ required: false, message: 'Please input director name!' }]}>
                    <Input />
                </Form.Item>
                <Form.Item label="Director ID Number" name="directorIdNumber" rules={[{ required: false, message: 'Please input director ID number!' }]}>
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Contact Name"
                    name="name"
                    rules={[
                        { required: true, message: 'Please input contact name' },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        { required: true, message: 'Please input a valid email address!' },
                        { type: 'email', message: 'The input is not a valid email!' },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Phone"
                    name="contactMobileNumber"
                    rules={[
                        { required: true, message: 'Please input a valid phone number!' },
                        { pattern: /^\d{10,15}$/, message: 'Phone number should be 10 to 15 digits!' },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item label="Settlement Bank Account Number" name="settlementBankNo" rules={[{ required: false, message: 'Please input bank account number!' }]}>
                    <Input />
                </Form.Item>

                <Form.Item label="Service Rate (%)" name="serviceRate" rules={[{ required: true, message: 'Please input service rate!' }]}>
                    <InputNumber min={0} max={100} step={0.01} />
                </Form.Item>
                <Form.Item label="Settlement Cycle (days)" name="settlementCycle" rules={[{ required: true, message: 'Please input settlement cycle!' }]}>
                    <InputNumber min={1} />
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 6 }} style={{ marginTop: 30 }}>
                    <Space>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                        <Button htmlType="reset" onClick={() => form.resetFields()}>
                            Reset
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </>
    );
};

export default NewMerchantPage;
